import React, { lazy, Suspense } from "react"
import { Router, Switch, Route, Redirect } from "react-router-dom"
import { HLink, HConfig } from "src/core/helpers"
import { getHomepageUrl, getMenuAllowedCodes } from "src/core/helpers/auth"
import { Sidebar } from "src/modules/app_dnt/constants/sidebar"
import AuthenticatedGuard from "src/guards/AuthenticatedGuard"
import PageGeneric from "src/pages/PageGeneric/PageGeneric"
// import PageNotFound from "src/pages/PageNotFound"
import { PATH } from "src/helpers/paths"
import Loading from "src/components/Loading/Loading"
import MainLayout from "src/layouts/MainLayout"
// import { CSuppense } from "src/core/components"
import MyPage from "src/core/components/MyPage/MyPage"
// const Home = lazy(() => import("src/pages/Home/Home"))
import Home from "src/pages/Home/Home"
import Login from "src/pages/Login/Login"
import Forgot from "src/pages/Login/Forgot"
import Reset from "src/pages/Login/Reset"
// import Register from "src/pages/Login/Register"
import {
  DashboardConfig,
  ScreenCode,
  Path,
} from "src/modules/app_dnt/constants/path"

const PageNotFoundv2 = lazy(() => import("src/pages/PageNotFound/not_found"))

export default function Routes() {
  const history = HLink.getHistory()
  const publicRoutes = HConfig.getPublicRoutes()
  const privateRoutes = HConfig.getPrivateRoutes()
  // console.warn("history:", history)
  return (
    <Router history={history}>
      <Switch>
        <AuthenticatedGuard
          exact
          path={PATH.HOME}
          component={props => {
            const homepageUrl = getHomepageUrl()
            if (homepageUrl !== PATH.HOME) {
              return <Redirect to={homepageUrl} />
            }
            const allowedCodes = getMenuAllowedCodes()
            if (
              allowedCodes.length === 0 ||
              !allowedCodes.includes(ScreenCode.HOME)
            ) {
              return <Redirect to={PATH.MY_PROFILE} />
            }
            return (
              <MainLayout {...props}>
                <Home />
              </MainLayout>
            )
          }}
        />
        <Route
          path={PATH.LOGIN}
          component={() => (
            <Suspense fallback={<Loading />}>
              <Login />
            </Suspense>
          )}
        />
        <Route path={PATH.FORGOT} component={() => <Forgot />} />
        {/* <Route path={PATH.REGISTER} component={() => <Register />} /> */}
        <Route path={`${PATH.RESET}/:tokenkey`} component={() => <Reset />} />
        <AuthenticatedGuard
          exact
          path={Path[ScreenCode.DASHBOARD]}
          component={props => {
            const allowedCodes = getMenuAllowedCodes()
            if (
              allowedCodes.length === 0 ||
              !allowedCodes.includes(ScreenCode.DASHBOARD)
            ) {
              return <Redirect to={PATH.MY_PROFILE} />
            }
            const configPage = DashboardConfig
            return (
              <MainLayout {...props}>
                <MyPage configPage={configPage} />
              </MainLayout>
            )
          }}
        />
        {privateRoutes?.map((v, i) => {
          return (
            <AuthenticatedGuard
              key={i}
              path={v.UIUrl || ""}
              component={props => {
                const sidebarCodes = Sidebar.list.map((s: any) => s.code)
                if (v.ScreenCode && sidebarCodes.includes(v.ScreenCode)) {
                  const allowedCodes = getMenuAllowedCodes()
                  if (
                    allowedCodes.length > 0 &&
                    !allowedCodes.includes(v.ScreenCode)
                  ) {
                    return (
                      <Suspense fallback={<Loading />}>
                        <PageNotFoundv2 />
                      </Suspense>
                    )
                  }
                }
                return <PageGeneric {...props} configPage={v} />
              }}
            />
          )
        })}
        {publicRoutes?.map((v, i) => {
          return (
            <Route
              key={i}
              path={v.UIUrl || ""}
              render={props => {
                return <PageGeneric {...props} configPage={v} />
              }}
            />
          )
        })}
        <Route
          key={"all"}
          path={"*"}
          exact={true}
          render={props => {
            return (
              <Suspense fallback={<Loading />}>
                <PageNotFoundv2 />
              </Suspense>
            )
          }}
        />
      </Switch>
    </Router>
  )
}
